import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import TableProvider from './contexts/TableContext';
import GlobalProvider from './contexts/GlobalContext';
import { BrowserRouter as Router } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <Router basename={process.env.REACT_APP_URL_BASENAME}>
            <TableProvider>
                <GlobalProvider>
                    <App />
                </GlobalProvider>
            </TableProvider>
        </Router>
    </React.StrictMode>
);

//Evita que se suban los valores de los inputs number con la rueda del ratón
document.addEventListener('wheel', function () {
    if (document.activeElement.type === 'number') {
        document.activeElement.blur();
    }
});
